import React from "react";
import MaximizedChat from "../../organisms/chat/maximizedChat/maximizedChat";
import { AppContext } from "../../../store/genesys.context";
import MinimizedChat from "../../organisms/chat/minimizedChat/minimizedChat";

const Chatbot = (): React.JSX.Element => {
  const {
    minimizeBot,
    hideLauncher,
  }: {
    minimizeBot: boolean;
    hideLauncher: boolean;
  } = React.useContext(AppContext);

  // A11Y FIX: focus management on open/close so keyboard and screen-reader
  // users are moved into the chat window when it opens and back to the
  // launcher when it closes.
  const windowRef = React.useRef<HTMLDivElement>(null);
  const launcherRef = React.useRef<HTMLDivElement>(null);
  const prevMinimize = React.useRef<boolean | null>(null);

  React.useEffect(() => {
    const prev = prevMinimize.current;
    prevMinimize.current = minimizeBot;

    // Skip the initial render (and StrictMode's double-invoke) so we never
    // steal focus on page load — only react to a real user-triggered toggle.
    if (prev === null || prev === minimizeBot) return;

    if (minimizeBot) {
      launcherRef.current?.focus();
    } else {
      windowRef.current?.focus();
    }
  }, [minimizeBot]);

  if (!minimizeBot) return <MaximizedChat ref={windowRef} />;

  // With `hideLauncher` the closed state renders nothing at all — the host page
  // provides the trigger (see mountChatbot's open()/close()). Focus then falls
  // back to the document instead of the launcher; there is no element of ours
  // left to return it to.
  return hideLauncher ? <></> : <MinimizedChat ref={launcherRef} />;
};
export default Chatbot;
